export const NavigationRoutes = {
  AUTH: '/auth',
  REGISTER: '/auth/register',
  LOGIN: '/',
};

export const AppRoutes = {
  INCORRECT_ROUTE: '*',
  STATUS_ROUTE: ':status',
  AUTH: '/auth/*',
  REGISTER: '/register',
  LOGIN: '/login',
  APP_COMPONENTS: '/components',
  HOME: '/home',
  ADMIN_INFO: '/admin-info',
  COMPANY_ADDRESS: '/company-address',
  COMPANY_DETAILS: '/company-details',
  LOGIN_VIEW: '/',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASS: '/forgot-password',
  SET_NEW_PASS: '/set-new-password',
  ADD_USER: '/add-user',
  PLAN_DETAILS: '/plan-details',
  DASHBOARD: '/dashboard',
  FORGOT_PASS_VERIFICATION: '/verify-forgot-pass',
  PRODUCT: '/products',
  IN_REVIEW: 'in-review',
  APPROVED: 'approved',
  DRAFT: 'draft',
  DECLINED: 'declined',
  BRANDS: 'brands',
  VALUE_CHAIN: '/value-chain',
  COMPANY_SETUP: '/company-setup',
  ACCOUNTS: '/accounts',
  USER_DETAILS: 'user-details',
  PRICING: 'pricing',
  COMPANY_DASHBOARD: '/company-dashboard',
  UTILITY_DASHBOARD: '/utility-dashboard',
  WASTE_DASHBOARD: '/waste-dashboard',
  FARMBOX: '/farm',
  CREATE_PRODUCT: '/product',
  CREATE_PRODUCT_RAW_MATERIAL: 'raw-material/:id',
  DOWNLOAD_MAP: '/download-map/:id',
  CREATE_PRODUCT_RAW_MATERIAL_TRANSPORTATION: 'transportation/:id',
  CREATE_PRODUCT_PROCESSING_FACILITY: 'processing-facility/:id',
  CREATE_PRODUCT_PRODUCT_DISTRIBUTION: 'product-distribution/:id',
  PROCESSING_FACILITY: 'processing-facility',
  SUPPLIER: 'suppliers',
  ADD_LOCATIONS: '/locations',
  PRODUCT_OVERVIEW: '/product-overview/:id',
  SCOPE_CALCULATOR: '/scope-calculator',
  PRODUCT_DASHBOARD: '/product-dashboard/:id',
  CREATE_PROCESSING_FACILITY: '/create-processing-facility/:id',
  CREATE_SUPPLIER: '/create-supplier/:id',
  CREATE_PRODUCT_MODAL: '/create-product/:userid',
  TERMS_AND_CONDITION: '/Terms&Conditions.pdf',
  ACTIVITY_DATA_ENTRY: '/activity-data-entry/:id',
  EDIT_ORGANISATION_MAP: '/edit-organization-map',
  ORGANISATION_DETAILS: '/organization-details/:id',
  CHILD_PRODUCTS: '/child-products',
  TARGETS: '/targets',
  SCOPE_3_CATEGORY_1: '/activity-data-entry/:id/scope-three/category-1',
  CATEGORY_2: '/activity-data-entry/:id/scope-three/category-2',
  CATEGORY_3: '/activity-data-entry/:id/scope-three/category-3',
  CATEGORY_4: '/activity-data-entry/:id/scope-three/category-4',
  CATEGORY_5: '/activity-data-entry/:id/scope-three/category-5',
  CATEGORY_6: '/activity-data-entry/:id/scope-three/category-6',
  CATEGORY_7: '/activity-data-entry/:id/scope-three/category-7',
  CATEGORY_8: '/activity-data-entry/:id/scope-three/category-8',
  CATEGORY_10: '/activity-data-entry/:id/scope-three/category-10',
  CATEGORY_11: '/activity-data-entry/:id/scope-three/category-11',
  CATEGORY_12: '/activity-data-entry/:id/scope-three/category-12',
  CATEGORY_13: '/activity-data-entry/:id/scope-three/category-13',
  CATEGORY_14: '/activity-data-entry/:id/scope-three/category-14',
  CATEGORY_15: '/activity-data-entry/:id/scope-three/category-15',
  FARM_CREATION: '/farm-creation',
  FARM_RAW_MATERIAL: '/farm-creation/raw-material/:id/:status',
  FARM_TRANSPORTATION: '/farm-creation/transportation/:id/:status',
  FARM_PRODUCT_PAGE_DRAFT: '/farm/draft',
  FARM_FUEL_AND_ENERGY: '/farm-creation/fuel-and-energy/:id/:status',
  FARM_COMMODITY_DISTRIBUTION:
    '/farm-creation/commodity-distribution/:id/:status',
  FARM_OVERVIEW_PAGE: '/farm-creation/overview/:id/:status',
  FARM_FIELD: '/farm-creation/field/:id/:status',
  FARM_LIVE_STOCK_CREATION: '/live-stock-creation',
  FARM_LIVE_STOCK_GROWTH_STAGE: '/live-stock-creation/growth-stage/:id/:status',
  FARM_LIVE_STOCK_FEED: '/live-stock-creation/transportation/:id/:status',
  FARM_LIVE_STOCK_FUEL_AND_ENERGY: '/live-stock-creation/fuel-and-energy/:id/:status',
  FARM_LIVE_STOCK_MANURE_MANAGEMENT: '/live-stock-creation/manure-management/:id/:status',
  FARM_LIVE_STOCK_COMMODITY_DISTRIBUTION: '/live-stock-creation/commodity-distribution/:id/:status',
  FARM_LIVE_STOCK_OVERVIEW: '/live-stock-creation/overview/:id/:status',

  API_KEYS: 'api-keys',
  API_REFERENCE: '/api-reference',
};
